export const notyf = new Notyf({
    duration: 2500,
    position: {
        x: 'right',
        y: 'top',
    },
    types: [
        {
            className: 'notyf__toast--success',
            type: 'success',
            background: '#93a160',
            dismissible: false
        },
        {
            className: 'notyf__toast--error',
            type: 'error',
            background: '#FF6363',
            dismissible: false
        }
    ]
});
